export default __webpack_public_path__ + "static/media/SignPainter.5a223a95.woff2";